import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

//Localization
import localizationReducer from "./localization/reducer"; // This will be removed in the next step
import alitqanCms from "./alitqanCms/reducer"; 

//Logs
import logsReducer from "./logs/reducer"; 

//Country
import countryReducer from "./country/reducer"; 

//Topic
import topicsReducer from "./topics/reducer"; 

//Sub
import subTopicsReducer from "./subTopic/reducer"; 

//Sub
import userTypeReducer from "./userType/reducer"; 

//Roles
import rolesReducer from "./roles/reducer"; 

//Users
import usersReducer from "./user/reducer"

//Module
import moduleReducer from "./module/reducer"; 

//AI Chat
import AIChatReducer from "./AIChat/reducer"; 

//AI Doc
import AIDocReducer from "./AIDoc/reducer"; 

//AI Category
import CategoryReducer from "./Category/reducer"; 

//Calendar
import CalendarReducer from "./calendar/reducer";

//Chat
import chatReducer from "./chat/reducer";

//Ecommerce
import EcommerceReducer from "./ecommerce/reducer";

//Project
import ProjectsReducer from "./projects/reducer";

// Tasks
import TasksReducer from "./tasks/reducer";

//Crypto
import CryptoReducer from "./crypto/reducer";

//TicketsList
import TicketsReducer from "./tickets/reducer";
//Crm
import CrmReducer from "./crm/reducer";

//Invoice
import InvoiceReducer from "./invoice/reducer";

//Mailbox
import MailboxReducer from "./mailbox/reducer";

// Dashboard Analytics
import DashboardAnalyticsReducer from "./dashboardAnalytics/reducer";

// Dashboard CRM
import DashboardCRMReducer from "./dashboardCRM/reducer";

// Dashboard Ecommerce
import DashboardEcommerceReducer from "./dashboardEcommerce/reducer";

// Dashboard Cryto
import DashboardCryptoReducer from "./dashboardCrypto/reducer";

// Dashboard Cryto
import DashboardProjectReducer from "./dashboardProject/reducer";

// Dashboard NFT
import DashboardNFTReducer from "./dashboardNFT/reducer";

// Pages > Team
import TeamDataReducer from "./team/reducer";

// File Manager
import FileManagerReducer from "./fileManager/reducer";

// To do
import TodosReducer from "./todos/reducer";

// Job
import JobReducer from "./jobs/reducer";

// API Key
import APIKeyReducer from "./apiKey/reducer";

// Human Categories
import HumanCategories from "./HumanCategories/reducer";

// Chat Report
import ChatReportReducer from "./ChatReport/reducer";

// Chat Report
import AiChatReportReducer from "./aiChatReport/reducer";

import CommonReducer from "./common/reducer";
import CourseReducer from "./courses/reducer";
import CourseModulesReducer from "./courseModules/reducer";
import CourseSessionsReducer from "./courseSessions/reducer";
import EnrollStudentsReducer from "./enrollStudents/reducer";
import ReferralRewardReducer from "./referralReward/reducer";
import ReferralEarnReducer from "./referralEarn/reducer";
import QuestionsReducer from "./questions/reducer";
import QuestionOptionsReducer from "./questionOptions/reducer";
import QuestionHintsReducer from "./questionHints/reducer";
import QuestionCategoryReducer from "./questionCategory/reducer";
import QuestionTypeReducer from "./questionType/reducer";
import DifficultyLevelReducer from "./difficultyLevel/reducer";
import AttemptScoreReducer from "./attemptScore/reducer";
import GPAReducer from "./gpa/reducer";
import ScoreReducer from "./score/reducer";
import TokenRefreshReducer  from "./tokenRefresh/reducer";
import AIPromptReducer  from "./AIPrompts/reducer";
import CaseReducer  from "./cases/reducer";
import CrawlReducer  from "./Crawl/reducer";
import NewsReducer  from "./News/reducer";
import SubscriptionPlanReducer  from "./SubscriptionPlan/reducer";
import SubscriptionPlanModuleReducer  from "./SubscriptionPlanModule/reducer";
import CouponReducer  from "./Coupon/reducer";
import UserPaymentReducer  from "./userPayments/reducer";
import ReportedIssuesReducer from "./ReportedLegalIssues/reducer";
import LawReportReducer  from "./lawReport/reducer";
import LegalRankReducer  from "./legalRank/reducer";
import ArticleActionReportReducer  from "./articleActionReport/reducer";
import ArticleActionReducer  from "./articleAction/reducer";
import ContactSupportReducer from "./ContactSupport/reducer";

const rootReducer = combineReducers({
    TokenRefresh: TokenRefreshReducer, 
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Localization: localizationReducer,
    AlitqanCms: alitqanCms,
    Profile: ProfileReducer,    
    Logs: logsReducer,
    Country: countryReducer,
    Topics: topicsReducer,
    SubTopics: subTopicsReducer,
    Roles: rolesReducer,
    Users: usersReducer,
    Module: moduleReducer,
    AIChat: AIChatReducer,
    AIDoc: AIDocReducer,
    AIPrompt: AIPromptReducer,
    Category: CategoryReducer,
    Calendar: CalendarReducer,
    Chat: chatReducer,
    Projects: ProjectsReducer,
    Ecommerce: EcommerceReducer,
    Tasks: TasksReducer,
    Crypto: CryptoReducer,
    Tickets: TicketsReducer,
    Crm: CrmReducer,
    Invoice: InvoiceReducer,
    Mailbox: MailboxReducer,
    DashboardAnalytics: DashboardAnalyticsReducer,
    DashboardCRM: DashboardCRMReducer,
    DashboardEcommerce: DashboardEcommerceReducer,
    DashboardCrypto: DashboardCryptoReducer,
    DashboardProject: DashboardProjectReducer,
    DashboardNFT: DashboardNFTReducer,
    Team: TeamDataReducer,
    FileManager: FileManagerReducer,
    Todos: TodosReducer,
    Jobs: JobReducer,
    APIKey: APIKeyReducer,
    Common: CommonReducer,
    Courses: CourseReducer,
    CourseModules: CourseModulesReducer,
    CourseSessions: CourseSessionsReducer,
    EnrollStudents: EnrollStudentsReducer,
    ReferralReward: ReferralRewardReducer,
    ReferralEarn: ReferralEarnReducer,
    Questions: QuestionsReducer,
    QuestionOptions: QuestionOptionsReducer,
    QuestionHints: QuestionHintsReducer,
    QuestionCategory: QuestionCategoryReducer,
    QuestionType: QuestionTypeReducer,
    DifficultyLevel: DifficultyLevelReducer,
    AttemptScore: AttemptScoreReducer,
    GPA: GPAReducer,
    Score: ScoreReducer,
    UserType: userTypeReducer,
    HumanCategories: HumanCategories,
    ChatReport: ChatReportReducer,
    AiChatReport: AiChatReportReducer,
    Cases: CaseReducer,
    Crawl: CrawlReducer,
    News: NewsReducer,
    SubscriptionPlan: SubscriptionPlanReducer,
    SubscriptionPlanModule: SubscriptionPlanModuleReducer,
    Coupon: CouponReducer,
    UserPayments: UserPaymentReducer,
    ReportedIssues: ReportedIssuesReducer,
    LawReport: LawReportReducer,
    LegalRank: LegalRankReducer,
    ArticleActionReport: ArticleActionReportReducer,
    ArticleAction: ArticleActionReducer,
    ContactSupport: ContactSupportReducer,
});

export default rootReducer;